<template>
  <div>
    <div class="se-topic">
      <div class="se-topic-left">
        <el-button
          style="margin-right: 20px"
          type="danger"
          @click="importIsShow"
        >
          导入题目
        </el-button>
        <!-- <el-button style="margin-right: 20px" type="danger" @click="addBatch">
          批量添加
        </el-button> -->
        <el-button
          style="margin-right: 20px"
          type="danger"
          @click="chooseVisible = true"
        >
          选择题目
        </el-button>
        <!-- <el-button
          style="margin-right: 20px"
          type="danger"
          @click="isShowAdd('add')"
        >
          添加题目
        </el-button> -->
        <el-dropdown @command="command">
          <el-button type="danger">
            添加题目<i class="el-icon-arrow-down el-icon--right"></i>
          </el-button>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item :command="1">单选题</el-dropdown-item>
            <el-dropdown-item :command="2">多选题</el-dropdown-item>
            <el-dropdown-item :command="3">填空题</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>

        <div class="se-list">
          <template v-for="v in examList">
            <div class="se-item" :key="v.id" v-if="v.questionType === 1">
              <div class="se-item-title">
                <span class=""
                  >【单选题，{{ v.score }}分】{{ v.questionName }}</span
                >
                <el-button
                  type="danger"
                  @click="delExam(v.id)"
                  style="max-height: 40px"
                  >删除</el-button
                >
              </div>
              <div class="se-item-body se-p-t-20">
                <el-radio-group v-model="v.answer" class="se-flex-v">
                  <el-radio
                    :label="s.id"
                    v-for="s in v.trainCourseQuestionOptions"
                    :key="s.id"
                    disabled
                    >{{ s.questionOption }}</el-radio
                  >
                </el-radio-group>
              </div>
            </div>
            <div class="se-item" :key="v.id" v-if="v.questionType === 2">
              <div class="se-item-title">
                <span>【多选题，{{ v.score }}分】{{ v.questionName }}</span>
                <el-button
                  style="max-height: 40px"
                  type="danger"
                  @click="delExam(v.id)"
                  >删除</el-button
                >
              </div>
              <div class="se-item-body se-p-t-20">
                <!-- <el-checkbox-group v-model="v.answer" class="se-flex-v">
                  <el-checkbox
                    :label="s.questionOption"
                    v-for="s in v.trainCourseQuestionOptions"
                    :key="s.id"
                    disabled
                  ></el-checkbox>
                </el-checkbox-group> -->
                <div class="se-flex-v">
                  <el-checkbox
                    :label="s.questionOption"
                    v-for="s in v.trainCourseQuestionOptions"
                    :key="s.id"
                    :checked="Boolean(s.isRight)"
                    disabled
                  ></el-checkbox>
                </div>
              </div>
            </div>
            <div class="se-item" :key="v.id" v-if="v.questionType === 3">
              <div class="se-item-title">
                <span>【填空题，{{ v.score }}分】{{ v.questionName }}</span>
                <el-button
                  style="max-height: 40px"
                  type="danger"
                  @click="delExam(v.id)"
                  >删除</el-button
                >
              </div>
              <div class="se-item-body se-p-t-20">
                <span v-for="(key, ii) of v.answer" :key="ii">
                  {{ key }}<span v-if="ii !== v.answer.length - 1">、</span>
                </span>
              </div>
            </div>
          </template>
        </div>
      </div>
      <div class="se-topic-right">
        <div style="margin-bottom: 10px">
          <span class="se-row">题目数量</span><span>{{ num }}</span>
        </div>
        <div style="margin-bottom: 10px">
          <span class="se-row">总分</span><span>{{ score }}</span>
        </div>
        <div style="margin-bottom: 10px">
          <span class="se-row">合格线</span>
          <el-input
            v-model="passScore"
            oninput="value=value.replace(/[^\d]/g,'')"
            type="number"
            style="width: 80px"
            placeholder=""
          />
        </div>
      </div>
    </div>
    <el-divider></el-divider>
    <div class="se-flex-h-c">
      <el-button @click="goBack">取消</el-button>
      <el-button type="danger" :loading="loading" @click="saveAll"
        >提交审核</el-button
      >
    </div>
    <!-- 导入题库对话框 -->
    <el-dialog
      title="导入题库"
      :visible.sync="visible"
      width="30%"
      destroy-on-close
    >
      <div>
        <div>第一步:</div>
        <div class="se-flex aic se-m-b-20">
          <div class="se-m-r-10">根据模版填写并上传文件</div>
          <a
            style="margin-left: 8px"
            href="../front-pc/template/topic.xls"
            target="_blank"
            download="导入题目模版.xls"
          >
            下载模板
          </a>
        </div>
        <div style="margin-bottom: 10px">
          <div class="" style="margin-bottom: 10px">第二步:</div>
          <div class="" style="margin-bottom: 10px">题库分类</div>
          <el-select v-model="uploadDate.dirId" placeholder="请选择">
            <el-option
              v-for="v in dirList"
              :key="v.id"
              :label="v.dirName"
              :value="v.id"
            >
            </el-option>
          </el-select>
        </div>
        <div class="se-m-b-10">第三步:</div>
        <div class="se-m-b-10">按照模板格式填写后上传Excel文件</div>
        <el-upload
          v-if="uploadDate.dirId"
          class="upload-demo"
          :action="`${baseURL}server/portal/personCenter/importCourse`"
          :headers="headers"
          :data="uploadDate"
          :on-remove="handleRemove"
          :file-list="fileList"
          :on-success="uploadFileSuccess"
        >
          <div class="se-flex aic se-upload-btn jcc">
            <i class="el-icon-plus" style="font-size: 12px; color: #e44352"></i>
            <div class="ft-12-red se-m-l-5">上传文件</div>
          </div>
        </el-upload>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="visible = false">取 消</el-button>
        <el-button type="primary" @click="visible = false">确 定</el-button>
      </span>
    </el-dialog>

    <el-dialog
      title="录入题库"
      :visible.sync="show"
      width="80%"
      destroy-on-close
    >
      <div>
        <div class="se-top">
          <el-form
            ref="form"
            class="se-form"
            :model="form"
            label-position="left"
          >
            <el-form-item label="题目分类">
              <el-select v-model="form.dirId" placeholder="请选择">
                <el-option
                  v-for="v in dirList"
                  :key="v.id"
                  :label="v.dirName"
                  :value="v.id"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-form>
          <div class="se-tip">
            <h3>标识说明:</h3>
            <div>@1: 题目</div>
            <div>@2: 题目类型</div>
            <div>@3: 题目选项(填空题无此项)</div>
            <div>@4: 答案</div>
            <div>@5: 解析</div>
          </div>
        </div>
        <div class="se-content">
          <div class="se-left">
            <div class="se-left-top">
              <div>输入区</div>
              <div>
                <el-button
                  type="danger"
                  style="margin-right: 20px"
                  @click="showTip = true"
                  >输入范例</el-button
                >
                <el-button type="danger" @click="content = ''">清空</el-button>
              </div>
            </div>
            <el-input
              type="textarea"
              style="height: 600px"
              placeholder="题目"
              v-model="content"
            />
          </div>
          <div class="se-right">
            <div class="se-right-top">识别区</div>
            <div class="se-right-bottom">
              <div class="se-item" v-for="(v, i) in test" :key="i">
                <div class="topic-title">
                  <div>题目{{ i + 1 }}</div>
                  <div>
                    {{
                      v[1].type === 1
                        ? "单选题"
                        : v[1].type === 2
                        ? "多选题"
                        : "填空题"
                    }}
                  </div>
                </div>
                <!-- <div v-for="(m, n) in v" :key="n">
                  <div>
                    <span>{{ m.label }}: </span>
                    <template v-if="m.field === 'trainCourseQuestionOptions'">
                      <span v-for="(j, k) in m.value" :key="k"
                        >{{ j.key }}:{{ j.questionOption }}
                      </span>
                    </template>
                    <template
                      v-else-if="m.field === 'answer' && Array.isArray(m.value)"
                    >
                      <span v-for="(j, k) in m.value" :key="k">{{ j }} </span>
                    </template>
                    <span v-else>{{ m.value }}</span>
                  </div>
                </div> -->
                <!-- <hr /> -->
                <template>
                  {{ v[0].value }}
                  <div v-if="v[1].value === '单选'" class="se-radio">
                    <!-- <a-radio :checked="s.key === v[3].value[0]" :value="s.key" v-for="(s, m) in v[2].value" :key="m">
                  {{ s.key }}、{{ s.questionOption }}
                </a-radio> -->
                    <el-radio
                      disabled
                      v-model="s.key"
                      :label="v[3].value[0]"
                      v-for="(s, m) in v[2].value"
                      :key="m"
                      >{{ s.key }}、{{ s.questionOption }}</el-radio
                    >
                    <div>解析:{{ v[4].value }}</div>
                  </div>
                  <div v-if="v[1].value === '多选'" class="se-radio">
                    <!-- <a-checkbox
                      v-for="(s, m) in v[2].value"
                      :key="m"
                      :checked="v[3].value.includes(s.key)"
                    >
                      {{ s.key }}、{{ s.questionOption }}
                    </a-checkbox> -->
                    <el-checkbox
                      disabled
                      :checked="v[3].value.includes(s.key)"
                      v-for="(s, m) in v[2].value"
                      :key="m"
                      >{{ s.key }}、{{ s.questionOption }}</el-checkbox
                    >
                    <div>解析:{{ v[4].value }}</div>
                  </div>
                  <div v-if="v[1].value === '填空'">
                    答案: {{ v[2].value.join(",") }}
                    <div>解析:{{ v[3].value }}</div>
                  </div>
                </template>
              </div>
            </div>
          </div>
        </div>
        <div class="se-bottom">
          <el-button
            type="info"
            style="margin-right: 20px"
            @click="show = false"
            >取消</el-button
          >
          <el-button type="danger" @click="submit">录入</el-button>
        </div>
      </div>
    </el-dialog>

    <el-dialog
      title="录入题库"
      :visible.sync="showTip"
      width="50%"
      destroy-on-close
    >
      <div style="height: 600px; overflow-y: auto">
        <h3>输入规则说明:</h3>
        <div style="margin: 10px 0; font-size: 16px; font-weight: 800">
          请严格按照输入规则输入!粘贴示例到输入区,修改题目名称,选项,答案,解析,即可!
        </div>
        <div>1.每个标识符(@1):后面必须加上一个空格,再输入内容,否则无法解析</div>
        <div>2.题目类型三种:单选,多选,填空</div>
        <div>
          3.@3为题目选项,四个选项ABCD(用大写),每个选项之间不用空格,用中划线 |
          分割,字母后面不要加顿号,逗号,具体见下方示例
        </div>
        <div>
          4.@3为题目选项,输入填空题时去掉此项,其他项标识符不变,具体见下方示例
        </div>
        <div>
          5.@4为答案,单选一个大写字母,多选大写字母之间用中划线 |
          分割,无需空格,填空题直接输入答案
        </div>
        <h3 style="padding-top: 10px">标识说明:</h3>
        <div>@1: 题目</div>
        <div>@2: 题目类型</div>
        <div>@3: 题目选项(填空题无此项)</div>
        <div>@4: 答案</div>
        <div>@5: 解析</div>
        <h3 style="padding-top: 10px">示例:</h3>
        <h3 style="padding-top: 10px">一、单选题</h3>
        <div>
          <div>@1 城市道路的设计最小纵坡为( )。</div>
          <div>@2 单选</div>
          <div>@3 A1|B2|C3|D4</div>
          <div>@4 A</div>
          <div>@5 这是解析</div>
        </div>
        <h3 style="padding-top: 10px">二、多选题</h3>
        <div>
          <div>@1 城市道路的设计最小纵坡为( )。</div>
          <div>@2 多选</div>
          <div>@3 A1|B2|C3|D4</div>
          <div>@4 A|B|C</div>
          <div>@5 这是解析</div>
        </div>
        <h3 style="padding-top: 10px">三、填空题</h3>
        <div>
          <div>@1 城市道路的设计最小纵坡为( )。</div>
          <div>@2 填空</div>
          <div>@4 1</div>
          <div>@5 这是解析</div>
        </div>
      </div>
    </el-dialog>

    <!-- 选择题目对话框 -->
    <el-dialog
      class="se-topic-dialog"
      title="选择题目"
      :visible.sync="chooseVisible"
      destroy-on-close
    >
      <choose-topic @selectTest="selectTest"></choose-topic>
      <span slot="footer" class="dialog-footer">
        <el-button @click="chooseVisible = false">取 消</el-button>
        <el-button type="primary" :loading="loading" @click="submitSelectTest"
          >添加题目</el-button
        >
      </span>
    </el-dialog>

    <!-- 添加题目 -->
    <!-- class="se-topic-dialog" -->
    <el-dialog
      title="添加题目"
      :visible.sync="addTopicVisible"
      :destroy-on-close="true"
      :close-on-click-modal="false"
    >
      <add-course-topic
        ref="editCourseTestRef"
        :trainCourseId="courseId"
        :questionType="questionType"
        @update="update"
      ></add-course-topic>
      <span slot="footer" class="dialog-footer">
        <el-button @click="addTopicVisible = false">取 消</el-button>
        <el-button type="danger" @click="addOk">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { baseURL } from "@/utils/request";
import chooseTopic from "./chooseTopic.vue";
import addCourseTopic from "./addCourseTopic.vue";

const fields = [
  { label: "标题", field: "questionName", value: "" },
  { label: "类型", field: "questionType", value: "", type: "" }, //  单选:1|多选2|填空:3
  {
    label: "内容",
    field: "trainCourseQuestionOptions",
    value: [{ key: "", sortNum: "", questionOption: "", isRight: "" }],
  },
  { label: "答案", field: "answer", value: [] },
  { label: "解释", field: "analysis", value: "" },
];

export default {
  props: {
    courseId: {
      type: String,
      default: "",
    },
  },

  components: {
    chooseTopic,
    addCourseTopic,
  },

  created() {
    this.getTopicClassify();
  },

  data() {
    return {
      baseURL,
      headers: {
        Authorization: `Bearer ${this.$store.state.token}`,
      },
      content: `
      @1 城市道路的设计最小纵坡为( )?
      @2 单选
      @3 A0.3%|B0.5%|C0.7%|D0.9%
      @4 A
      @5 这是解析

      @1 城市道路的设计最小纵坡为( )?
      @2 多选
      @3 A0.3%|B0.5%|C0.7%|D0.9%
      @4 A|B
      @5 这是解析

      @1 城市道路的设计最小纵坡为( )?
      @2 填空
      @4 0.3%
      @5 这是解析
      `,
      showTip: false,
      show: false,
      radio: "",
      checkList: [],
      visible: false,
      data: {},
      fileList: [],
      examList: [],
      num: 0,
      score: 0,
      passScore: null,
      uploadDate: {
        courseBelong: 1,
        dirId: null,
        trainCourseId: this.courseId,
      },
      chooseVisible: false,
      selectTopic: [],
      selectTopicForm: {
        courseBelong: 1,
        trainCourseId: this.courseId,
        questionIds: [],
      },
      form: {
        dirId: null,
      },
      dirList: [],
      loading: false,
      addTopicVisible: false,
      addTopicType: "",
      questionType: null,
      detail: {},
    };
  },

  computed: {
    test() {
      return this.parse();
    },
  },

  mounted() {
    this.getCourseExam();
  },

  methods: {
    addBatch() {
      this.form.dirId = null;
      this.show = true;
    },

    async saveAll() {
      if (!this.examList.length) {
        this.$message.info("请添加题目");
        return;
      }
      if (!this.passScore) {
        this.$message.info("请输入合格线");
        return;
      }

      if (this.passScore > this.score) {
        this.$message.info("合格线不能大于总分");
        return;
      }
      this.loading = true;
      await this.$http.put("server/portal/personCenter/addPassScore", {
        id: this.courseId,
        passScore: Number(this.passScore),
      });
      await this.$http.post(
        `server/portal/personCenter/submitAudit/${this.courseId}`
      );
      this.$emit("goHome");
      this.loading = false;
    },
    async delExam(id) {
      await this.$http.del(
        `server/portal/personCenter/removeTrainCourseQuestion/${id}`
      );
      this.getCourseExam();
    },
    async addQuestion(form) {
      await this.$http.post(
        "server/portal/personCenter/batchAddTrainCourseQuestion",
        {
          courseBelong: 1,
          trainCourseId: this.courseId,
          dirId: this.form.dirId,
          trainCourseQuestionList: form,
        }
      );
      this.show = false;
      // setTimeout(() => {
      this.getCourseExam();
      // }, 2000);
      // this.$forceUpdate()
    },
    parse() {
      return (
        this.content.replace(/[\n\r]/g, "").match(/@[1-5]{1}\s[^@]*/g) || []
      ).reduce((t, v) => {
        if (v.includes("@1")) {
          t.push([this.getField(v)]);
        } else {
          t.slice(-1)[0].push(this.getField(v));
        }
        return t;
      }, []);
    },
    getField(value) {
      const value_ = value;
      const item = fields.find((v, i) => value_.includes(`@${i + 1}`));
      let type = "";
      value = value_.replace(/\s/g, "").slice(2, value_.lenght);
      if (value_.includes("@2")) {
        type = this.getType(value);
      } else if (value_.includes("@3")) {
        value = this.getContent(value);
      } else if (value_.includes("@4")) {
        value = this.getAnswer(value);
      }
      return {
        ...item,
        value,
        value_,
        type,
      };
    },
    getType(value) {
      if (value.includes("单选")) {
        return 1;
      } else if (value.includes("多选")) {
        return 2;
      } else if (value.includes("填空")) {
        return 3;
      }
    },

    getContent(value) {
      // A1|B2|C3|D4
      return value.split("|").map((v, i) => {
        const key = v.substring(0, 1);
        const questionOption = v.substring(1, v.length);
        // const [key, questionOption] = v.split('')
        return { key, sortNum: i + 1, questionOption };
      });
    },

    getAnswer(value) {
      return value.split("|");
    },
    submit() {
      if (!this.form.dirId) return this.$message.error("请选择分类");
      const list = this.parse();
      const form = list.reduce((t, v) => {
        const item = {};
        v.forEach((m, n) => {
          if (m.field === "questionType") {
            item[m.field] = m.type;
          } else if (m.field === "trainCourseQuestionOptions") {
            item[m.field] = m.value.map((j, k) => {
              const answer = v[n + 1].value;
              return {
                ...j,
                isRight: answer.includes(j.key) ? 1 : 0,
              };
            });
          } else if (m.field === "answer") {
            if (v.find((j, k) => j.type === 3)) {
              item.trainCourseQuestionOptions = m.value.map((v, i) => ({
                sortNum: i + 1,
                questionOption: v,
                isRight: 1,
              }));
            }
          } else {
            item[m.field] = m.value;
          }
        });
        t.push({ ...item, score: 5 });
        return t;
      }, []);
      // const obj = {};
      // obj.dirId = this.form.dirId;
      // obj.form = form;
      // console.log(list);
      // console.log(form);
      this.addQuestion(form);
      // const obj = {};
      // obj.dirId = this.form.dirId;
      // obj.form = form;
      // this.$emit("batchAddTest", obj);
    },
    async getCourseExam() {
      const {
        data: { trainCourseQuestions, num, score },
        data,
      } = await this.$http.get(
        `server/portal/personCenter/getCourseExam/${this.courseId}`
      );
      this.examList = trainCourseQuestions.map((s) => {
        const answer =
          s.questionType === 1
            ? s.trainCourseQuestionOptions.length !== 0 &&
              s.trainCourseQuestionOptions.find((k) => k.isRight).id
            : s.questionType === 2 || s.questionType === 3
            ? s.trainCourseQuestionOptions
                .filter((k) => k.isRight)
                .map((k) => {
                  return k.questionOption;
                })
            : "";
        return {
          ...s,
          answer,
        };
      });
      // console.log(this.examList);
      this.data = data;
      this.num = num;
      this.score = score;
    },

    // 导入题目按钮
    importIsShow() {
      this.uploadDate.dirId = null;
      this.visible = true;
    },

    // 文件列表移除文件时的钩子
    handleRemove(file, fileList) {
      // console.log(file, fileList);
    },

    // 返回
    goBack() {
      this.$emit("back");
    },

    // 导入题目回调
    uploadFileSuccess(file, res, fileList) {
      // console.log(file, "file");
      // console.log(res, "res");
      // console.log(fileList, "fileList");
      if (file.code === 200) {
        this.visible = false;
        this.$message.success("导入成功");
        this.getCourseExam();
      } else {
        this.$message.error(file.msg);
      }
    },

    // 获取选择的题目
    selectTest(value) {
      // console.log(value, "value");
      this.selectTopic = value;
    },

    // 提交选择题目
    async submitSelectTest() {
      if (!this.selectTopic.length) return this.$message.info("请选择题目");
      this.loading = true;
      this.selectTopicForm.questionIds = this.selectTopic.map((v) => {
        return v.id;
      });
      await this.$http.post(
        "/server/api/coursequestion/batchSelectQuestionAndAdd",
        this.selectTopicForm
      );
      this.chooseVisible = false;
      await this.getCourseExam();
      this.loading = false;
      // console.log(this.selectTopicForm, "selectTopicForm");
    },

    // 获取题目分类
    async getTopicClassify() {
      const data = await this.$http.get("/server/api/dir/list");
      // console.log(data);
      this.dirList = data.rows;
    },

    isShowAdd(type) {
      this.addTopicType = type;
      this.addTopicVisible = true;
    },

    // 展示添加题目
    command(e) {
      // console.log(e);
      this.questionType = e;
      // this.detail.questionType = e;
      this.addTopicVisible = true;
    },

    addOk() {
      this.$refs.editCourseTestRef.confirm();
    },

    // 添加题目后更新列表
    update() {
      this.addTopicVisible = false;
      this.getCourseExam();
    },
  },
};
</script>

<style lang="scss" scoped>
.se-topic {
  display: flex;
  justify-content: space-between;
  .se-topic-left {
    flex: 1;
  }
  .se-topic-right {
    padding-right: 40px;
    width: 220px;
  }
}

.se-list {
  margin-top: 20px;
}

.se-item {
  position: relative;
  border: 1px solid #ccc;
  width: 90%;
  border-radius: 5px;
  margin-bottom: 20px;
  padding: 20px;
}

.se-item-body {
  padding-left: 10px;
}

.se-row {
  display: inline-block;
  width: 100px;
  padding-right: 20px;
}

/deep/ .el-radio {
  margin-bottom: 10px;
}

/deep/ .el-checkbox {
  margin-bottom: 15px;
}

/deep/ .el-radio__input.is-checked .el-radio__inner {
  border-color: #e44352;
  background: #e44352;
}

/deep/ .el-radio__input.is-checked + .el-radio__label {
  color: #e44352;
}

/deep/ .el-checkbox__input.is-checked .el-checkbox__inner,
.el-checkbox__input.is-indeterminate .el-checkbox__inner {
  border-color: #e44352;
  background: #e44352;
}

/deep/ .el-checkbox__input.is-checked + .el-checkbox__label {
  color: #e44352;
}

/deep/ .el-radio__inner:hover {
  border-color: #e44352;
}

/deep/ .el-checkbox__inner:hover {
  border-color: #e44352;
}

/deep/ .el-textarea {
  textarea {
    height: 100%;
  }
}

.se-upload-btn {
  width: 110px;
  height: 30px;
  line-height: 30px;
  text-align: center;
  background-color: #fff;
  border: 1px solid #e44352;
}

.se-content {
  display: flex;
  justify-content: space-between;
}

.se-left {
  width: 49%;
  overflow-y: auto;
}

.se-left-top {
  height: 60px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px;
  background-color: #e4f1f6;
}

.se-right {
  width: 49%;
  overflow-y: auto;
}

.se-right-top {
  height: 60px;
  padding: 10px;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  background-color: #e4f1f6;
}

.se-right-bottom {
  height: 603px;
  overflow-y: auto;
  padding: 15px;
  border: 1px solid #ccc;
}

.se-bottom {
  display: flex;
  justify-content: center;
  border: 1px solid #ccc;
  padding: 10px 0;
}

.se-item {
  padding: 10px;
  border: 1px solid #ccc;
  margin-bottom: 10px;
}

.se-item-title {
  display: flex;
  justify-content: space-between;
}

/deep/ .se-topic-dialog .el-dialog__body {
  padding: 0;
}

.se-top {
  display: flex;
  align-items: center;
  justify-content: space-between;
  .se-form {
    width: 49%;
  }
  .se-tip {
    width: 49%;
  }
}

.se-tip {
  border: 1px solid #ccc;
  padding: 10px 20px;
  margin-bottom: 10px;
}

.topic-title {
  display: flex;
  justify-content: space-between;
}

.se-radio {
  padding-top: 10px;
  display: flex;
  flex-direction: column;
}
</style>
